export default "__VITE_ASSET__yu8pLW6N__"